import { useEffect, useRef } from 'react';

function AddToAnyButton() {
  const a2aTarget = useRef();

  useEffect(() => {
    if (!window.a2a) return;

    window.a2a.init('page', {
      target: a2aTarget.current,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [a2aTarget.current]);

  return (
    <div>
      Compartir
      {/* See more here https://www.addtoany.com/ */}
      <div ref={a2aTarget} className="a2a_kit a2a_kit_size_32 a2a_default_style">
        {/* eslint-disable */}
        <a className="a2a_dd" href="https://www.addtoany.com/share" />
        <a className="a2a_button_whatsapp" />
        <a className="a2a_button_facebook_messenger" />
        <a className="a2a_button_telegram" />
        {/* eslint-enable */}
      </div>
    </div>
  );
}

export default AddToAnyButton;
